export const environment = {
  production: false,

  // apiUrl: 'https://admin.fliptronic.pl/api/',
  // socketUrl: 'https://mercure.fliptronic.pl/'

  apiUrl: 'https://admin.fliptronic.dev.palladio.net.pl/api/',
  socketUrl: 'https://mercure.fliptronic.dev.palladio.net.pl/'

  // apiUrl: 'http://192.168.1.223:8009/api/',
  // socketUrl: 'http://192.168.1.223:8089/',

  // apiUrl: 'http://localhost:8009/api/',
  // socketUrl: 'http://localhost:8089/',

  // apiUrl: 'http://12.20.100.31:8009/api/',
  // socketUrl: 'http://12.20.100.31:8009/'
};
